import {
    Box, PopoverArrow, PopoverBody, Text, VStack,
} from '@chakra-ui/react';

export function NonManagedPortfolioPopoverContent() {
    return (
        <>
            <PopoverArrow />
            <PopoverBody fontSize="sm">
                <VStack gap={2} align="start">
                    <Box mt={2}>
                        <Text fontWeight="bold">Compliant*</Text>
                        <Text color="muted.700">
                            A property will be listed as Compliant* where Your Data includes
                            a service provider and last service date for all required services,
                            and services are not overdue.
                        </Text>
                    </Box>

                    <Box mt={2}>
                        <Text fontWeight="bold">Compliance issues*</Text>
                        <Text color="muted.700">
                            A property will be listed as having Compliance issues* where
                            Your Data does not include a service provider and/or last service
                            date for all required services, or where last service dates are
                            provided, the services are overdue.
                        </Text>
                    </Box>
                </VStack>
            </PopoverBody>
        </>
    );
}
